module.exports = __webpack_public_path__ + "static/img/partner_IX.1e36b31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_IX.png
// module id = o6eK
// module chunks = 9